import {
    UPDATE_BOOKING,
    UPDATE_BOOKING_FAILURE,
    UPDATE_BOOKING_SUCCESS,
} from 'store/actions/types';

export const updateBooking = (payload) => {
    return {
        type: UPDATE_BOOKING,
        payload: payload,
    };
};

export const updateBookingFailure = (error) => {
    return {
        type: UPDATE_BOOKING_FAILURE,
        error: error,
    };
};

export const updateBookingSuccess = (id, response) => {
    return {
        type: UPDATE_BOOKING_SUCCESS,
        id: id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/bookings/updateBookings.js